import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormsModule,
  Validators,
} from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
  createServiceFields,
  createServiceFieldsEdit,
} from "../../../core/generic-templates/dynamic-form-template";
import { MaterialModule } from "../../../core/shared/material.module";
import { DynamicFormComponent } from "../../common/dynamic-form/dynamic-form.component";

@Component({
  selector: "app-create-service-modal",
  standalone: true,
  imports: [CommonModule, FormsModule, DynamicFormComponent, MaterialModule],
  templateUrl: "./create-service-modal.component.html",
  styleUrl: "./create-service-modal.component.scss",
})
export class CreateServiceModalComponent implements OnInit {
  activeModal = inject(NgbActiveModal);
  dynamicForm: any = new FormGroup({});
  authenticationType: any = "basic";
  data: any = {};
  fields: any = [];
  isExpanded = false;
  scopeList: any = [];
  isActive: boolean = false;

  @Input() configs: any;

  ngOnInit(): void {
    if (this.configs?.isEdit) {
      this.fields = createServiceFieldsEdit;
      this.dynamicForm.reset();
      Object.keys(this.dynamicForm.controls).forEach((key) => {
        this.dynamicForm.removeControl(key);
      });

      this.fields.forEach((field: any) => {
        this.dynamicForm.addControl(
          field.key,
          new FormControl(
            "",
            field.validations?.required ? Validators.required : []
          )
        );
      });

      this.data = {
        username: null,
        password: null,
        authUrl: null,
        accessTokenUrl: null,
        clientId: null,
        clientSecret: null,
        scope: null,
        ...(this.configs?.data?.authentication?.credentials || {}),
      };
      this.dynamicForm.patchValue({
        name: this.configs?.data?.name,
        url: this.configs?.data?.url,
      });
      this.authenticationType = this.configs?.data?.authentication?.type;
    } else {
      this.fields = createServiceFields;
      this.data = {
        username: null,
        password: null,
        authUrl: null,
        accessTokenUrl: null,
        clientId:null,
        clientSecret: null,
        scope: null,
      };
      this.authenticationType = "basic";
    }
  }

  expand() {
    this.isExpanded = !this.isExpanded;
  }

  onAuthTypeChange(type: string): void {
    this.authenticationType = type;
    if (type === "basic") {
      this.data.authUrl = null;
      this.data.accessTokenUrl = null;
      this.data.clientId = null;
      this.data.clientSecret = null;
      this.data.scope =null;
    } else if (type === "OAUTH") {
      this.data.username = null;
      this.data.password = null;
    }
  }

  save() {
    let data;
    if (this.configs.isEdit) {
      data = {
        ...this.dynamicForm.value,
        name: this.configs?.data?.name,
        authentication: {
          type: this.authenticationType,
          credentials: this.data,
        },
      };
    } else {
      data = {
        ...this.dynamicForm.value,
        authentication: {
          type: this.authenticationType,
          credentials: this.data,
        },
      };
    }
    this.activeModal.close(data);
  }

  processScopeInput() {
    if (this.data?.scope?.trim()) {
      this.scopeList = this.data?.scope
        .split(",")
        .map((item: any) => item.trim())
        .filter((item: any) => item); // removes empty strings

      this.data.scope = this.scopeList;
    }
  }
}
